import React, { useState, useEffect } from 'react';
import Header from "../../../header/header";
import Footer from "../../../footer/footer";
import Sidebar from "../../../Sidebar/Sidebar";
import { getOrderDetails } from "../../service";
import Skeleton from "../../component/skeleton";

function Savings() {
    const [savingsList, setsavingsList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getOrderList();
    }, []);

    const getOrderList = async () => {
        try {
            const res = await getOrderDetails({ cat_id: '' });
            setsavingsList(res.data);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Header />
            <div className="flex">
                <Sidebar />
                <main className="flex-1 p-5 bg-gray-100">
                    <h1 className="text-[46px] font-bold">Savings Details</h1>
                    <p className="text-gray-500 mb-4 text-[14px]">
                        Dashboard / <span className='font-semibold'>Savings Details</span>
                    </p>

                    {loading ? (
                        <div className="w-full mt-10 py-[50px] px-[20px] bg-white">
                            <Skeleton width='100%' />
                        </div>
                    ) : (
                        <div className="container mx-auto mt-10 py-[50px] px-[20px] bg-white">
                            <table className="w-full border-collapse border border-gray-300">
                                <thead className="bg-gray-100">
                                    <tr>
                                        <th className="border border-[#E9ECEF] px-4 py-2 text-[#6C757D] text-[12px] font-semibold w-[70%]">
                                            Name
                                        </th>
                                        <th className="border border-[#E9ECEF] px-4 py-2 text-[#6C757D] text-[12px] font-semibold text-center">
                                            Savings
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {savingsList.map((item, index) => (
                                        <tr key={index} className="even:bg-gray-50">
                                            <td className="border border-[#E9ECEF] px-4 py-2 text-[##343A40] text-[14px]">
                                                {item?.name}
                                            </td>
                                            <td className="border border-[#E9ECEF] px-4 py-2 text-[#343A40] text-[14px] text-center">
                                                {item?.saving_price}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </main>
            </div>
            <Footer />
        </>
    );
}

export default Savings;
